import React from 'react';
import { Alert, AlertTitle, Button, Card, CardHeader, Collapse, IconButton, CardContent, } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { defineMessages, useIntl } from 'react-intl';
import { ConfirmationDialog } from '../dialog';
const msgs = defineMessages({
    alertContent: {
        id: 'card.DeleteCard.alert.content',
        defaultMessage: 'Pressing the delete button will show you a dialog to confirm your intent before proceeding.',
    },
    headerTitle: {
        id: 'card.DeleteCard.header.title',
        defaultMessage: 'Settings',
    },
    headerSubTitle: {
        id: 'card.DeleteCard.header.subTitle',
        defaultMessage: 'Critical action. Be careful when you execute this.',
    },
    buttonDelete: {
        id: 'card.DeleteCard.button.delete',
        defaultMessage: 'Delete',
    },
    dialogConfirmationTitle: {
        id: 'card.DeleteCard.dialog.confirmationTitle',
        defaultMessage: 'Confirm',
    },
    dialogDeleteConfirmationContent: {
        id: 'card.DeleteCard.dialog.deleteConfirmationContent',
        defaultMessage: 'Are you really going to delete this item?',
    },
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ExpandMore = styled(({ expand, ...props }) => {
    return React.createElement(IconButton, { ...props });
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
function DeleteCard({ title, onDelete }) {
    const intl = useIntl();
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [expanded, setExpanded] = React.useState(false);
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(ExpandMore, { expand: expanded, onClick: () => setExpanded((e) => !e), "aria-expanded": expanded, "aria-label": "show more" },
                React.createElement(ExpandMoreIcon, null)) }),
        React.createElement(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true },
            React.createElement(CardContent, null,
                React.createElement(Alert, { icon: false, severity: "error", sx: { width: '100%' }, action: React.createElement(Button, { color: "error", onClick: () => setDeleteDialogOpen(true), sx: { alignSelf: 'center' } }, intl.formatMessage(msgs.buttonDelete)) },
                    React.createElement(AlertTitle, null, title),
                    intl.formatMessage(msgs.alertContent)))),
        React.createElement(ConfirmationDialog, { open: deleteDialogOpen, title: intl.formatMessage(msgs.dialogConfirmationTitle), description: intl.formatMessage(msgs.dialogDeleteConfirmationContent), onCancel: () => setDeleteDialogOpen(false), onConfirm: () => {
                setDeleteDialogOpen(false);
                onDelete();
            } })));
}
export default React.memo(DeleteCard);
